import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface PendingDownload {
  claimNumber: string;
  totalDocuments: number;
  processedDocuments: number;
}

@Component({
  selector: 'epa-pending-download',
  templateUrl: './epa-pending-download.component.html',
  styleUrls: ['./epa-pending-download.component.scss']
})
export class EpaPendingDownloadComponent {
  @Input() pendingDownloads: PendingDownload[] = [];
  @Output() downloadReady = new EventEmitter<string>();

  getProgress(item: PendingDownload): number {
    if (!item.totalDocuments) return 0;
    return Math.round((item.processedDocuments / item.totalDocuments) * 100);
  }
}
